import { useTranslation } from 'react-i18next';

import './DiagramGridEmpty.scss';

function DiagramGridEmpty({ onCreate }) {
    const { t } = useTranslation();

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onCreate?.();
        }
    };

    return (
        <div
            className="diagram-grid-empty"
            role="button"
            tabIndex={0}
            onClick={onCreate}
            onKeyDown={handleKeyDown}
        >
            <div className="empty-title">
                <svg width="17px" height="17px" viewBox="0 0.7 24 24" fill="none" stroke="rgb(164, 175, 177)" strokeWidth="2.3px" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"></path></svg>
                {t('t.ctrl_top_left.new_diagram')}
            </div>
            {/* <div className="empty-icon" aria-hidden="true">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2"
                     strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 5v14M5 12h14" />
                </svg>
            </div>
            <div className="empty-title">Create your first diagram</div>
            <div className="empty-subtitle">Start with a blank canvas or import SQL.</div> */}
        </div>
    );
}

export default DiagramGridEmpty;
